import { getConsultantId, getConsultantIdentifier } from '../Redux/UsersDucks'
import { getFileNameFromHeader } from '../Utilities/Utilities'
import api from './api'
import ErrorService from './errorService'
import Swal from 'sweetalert2'
import { saveAs } from 'file-saver';
import { Email } from '@mui/icons-material'

export const FirmaService = {
  sendESign: async (contractLineId, type, emailSign, checked) => {
    try {
      const consultantIdentifier = getConsultantIdentifier()
      if (!consultantIdentifier) {
        throw new Error('Consultor. Se debe de ingresar en el sistema es requerido su rut.');
      }
      var userId = Number(getConsultantId())
      var signatureType = 0;
      var url = null;
      if (type == "TF") url = "tuFirma";
      else if (type == "XL") url = "xmartlab";
      else if (type == "GD") {
        url = "grupoDefensa";
        signatureType = checked ? 12 : 13;
      }

      //var url = type == "TF" ? "tuFirma" : ("XL" ? "xmartlab" : null)

      const response = await ErrorService.withTimeout(api.post(`/ElectronicSignature/${url}/Send`,
        {
          ContractLineId: contractLineId,
          IdSending: userId,
          EmailSign: emailSign,
          signatureType,
          CreateBy: consultantIdentifier
        }))

      // Mostrar mensaje de éxito usando Swal
      Swal.fire({
        icon: 'success',
        title: '¡Éxito!',
        text: 'Contrato Enviado A Firmar.',
        confirmButtonText: 'Aceptar'
      })
      console.log('Contrato Enviado A Firmar:', response)
      return response.data.enviado

    } catch (error) {
      throw error
    }
  },

  sendManualSign: async (contractLineId, type, emailSign) => {
    try {
      const consultantIdentifier = getConsultantIdentifier()
      if (!consultantIdentifier)
        throw new Error('Consultor. Se debe de ingresar en el sistema es requerido su rut.')

      var userId = Number(getConsultantId())

      await api.post(`/ElectronicSignature/manual/Send`,
        {
          ContractLineId: contractLineId,
          IdSending: userId,
          EmailSign: emailSign,
          CreateBy: consultantIdentifier,
        },
        {
          responseType: 'blob'
        })
        .then(response => {
          const file = new Blob([response.data], { type: response.headers['content-type'] });
          const filename = getFileNameFromHeader(response.headers['content-disposition']);
          saveAs(file, 'contrato');
        })
        .catch(error => {
          console.error('Error al descargar archivo:', error);
        });

      // Mostrar mensaje de éxito usando Swal
      Swal.fire({
        icon: 'success',
        title: '¡Éxito!',
        text: 'Contrato Descargado, espere mientras refresca la pagina',
        confirmButtonText: 'Aceptar'
      })
      return true

    } catch (error) {
      return false
      throw error
    }
  },
  GetESign: async (contractLineId, type) => {
    try {
      const consultantIdentifier = getConsultantIdentifier()
      if (!consultantIdentifier) {
        throw new Error('Consultor. Se debe de ingresar en el sistema es requerido su rut.');
      }

      var url = null;
      if (type == "TF")      url = "tuFirma";
      else if (type == "XL") url = "xmartlab";
      else if (type == "GD") url = "grupoDefensa";

      //var url = type == "TF" ? "tuFirma" : "xmartlab"



      const response = await ErrorService.withTimeout(api.get(`/ElectronicSignature/${url}/Get?idContactLine=${contractLineId}&createBy=${consultantIdentifier}`/*, {
        params: { idContactLine: contractLineId }
      }*/))
      return response.data
    } catch (error) {
      console.error('Error al crear Firma:', error)
      throw error
    }
  },

  CancelESign: async (contractLineId, type) => {
    try {
      const consultantIdentifier = getConsultantIdentifier()
      if (!consultantIdentifier) {
        throw new Error('Consultor. Se debe de ingresar en el sistema es requerido su rut.');
      }
      /*
      var url = ""
      if ("MANUAL" == type)
        url = "manual"
      else if (type == "TF")
        url = "tuFirma"
      else if (type == "XL")
        url = "xmartlab"
      */
      var url = null;
      if (type == "TF")      url = "tuFirma";
      else if (type == "XL") url = "xmartlab";
      else if (type == "GD") url = "grupoDefensa";

      const response = await ErrorService.withTimeout(api.get(`/ElectronicSignature/${url}/Cancel?idContactLine=${contractLineId}&createBy=${consultantIdentifier}`/*, {
        params: { contractLineId }
      }*/))
      return response.data
    } catch (error) {
      console.error('Error al crear Firma:', error)
      Swal.fire({
        title: "error interno, refreseque e intente nuevamente, si el problema continua contacte a Tecnologia",
        icon: "warning",
        showConfirmButton: true,
        timer: 4000,
      })
      throw error
    }
  },

  UploadSign: async (contractLineId, files) => {
    const consultantIdentifier = getConsultantIdentifier()
    if (!consultantIdentifier) {
      throw new Error('Consultor. Se debe de ingresar en el sistema es requerido su rut.');
    }

    if (files.length === 0) {
      return {
        message: 'Por favor selecciona al menos un archivo',
        cancelado: false,
        firmado: false
      }
    }

    try {
      const formData = new FormData();
      files.forEach(file => {
        formData.append('Archivo', file) // Asegúrate que tu API espera 'files' como nombre
      });
      formData.append('UserUpload', consultantIdentifier)
      formData.append('ContractLineId', contractLineId)
      formData.append('Description', "test")

      const response = await ErrorService.withTimeout(
        api.post(`/ElectronicSignature/manual/upload`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }))

      return {
        message: 'Contrato firmado almacenado ',
        cancelado: false,
        firmado: true
      }
    } catch (error) {
      console.log(error.response?.data?.message || 'Error al subir los archivos')
      return {
        message: 'Error al subir los archivos',
        cancelado: false,
        firmado: false
      }
    }
  },
}

export default FirmaService